import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import {CmsConfig, I18nModule, provideConfig, provideDefaultConfig, UrlModule} from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { UigAddToWishlistComponent } from './uig-add-to-wishlist.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        UrlModule,
        IconModule,
        I18nModule,
    ],
    providers: [
        provideConfig(<CmsConfig>{
            cmsComponents: {
                AddToWishListComponent: {
                    component: UigAddToWishlistComponent,
                },
            },
        }),
    ],
    declarations: [UigAddToWishlistComponent],
    exports: [UigAddToWishlistComponent]
})
export class UigAddToWishlistModule { }
